import colors from '../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        alignment: {
            '&:hover': {
                backgroundColor: 'transparent'
            },
            alignItems: 'flex-start'
        },
        centralLanguageButton: {
            background: 'white',
            boxShadow: 'none',
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            margin: '10px'
        },
        hideTitle: {
            marginRight: '0px',
            paddingLeft: '50px'
        },
        languageButton: {
            boxShadow: 'none',
            color: colors[mode].titleColor,
            float: 'right',
            margin: '10px',
            width: '120px'
        },
        languageButtonLogin: {
            '&:hover': {
                boxShadow: 'none',
            },
            boxShadow: 'none',
            color: 'white',
            float: 'right',
            margin: '10px',
            width: '120px'
        },
        languageButtonLoginMain: {
            '&:hover': {
                backgroundColor: 'rgb(0, 74, 136)',
                boxShadow: 'none',
            },
            backgroundColor: 'unset',
            boxShadow: 'none',
            color: 'white',
            float: 'right',
            margin: '10px',
            width: '120px'
        },
        mobileLanguageButton: {
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            marginLeft: '65%',
            width: '35%'
        },
        mobileLanguageButtonCustom: {
            '@media screen and (max-width: 395px)': {
                marginLeft: '115px'
            },
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            marginLeft: '155px',
            width: '35%'
        },
        mobileLanguageButtonCustomFr: {
            '@media screen and (max-width: 395px)': {
                marginLeft: '90px'
            },
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            marginLeft: '130px',
            width: '35%'
        },
        mobileLanguageButtonDefault: {
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgba(0, 49, 104, 0.9)',
            float: 'right',
            fontSize: '12px',
            fontWeight: '400',
            width: '35%'
        },
        mobileLanguageButtonRegister: {
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            width: '35%'
        }
    }
}

export default styles
